import { execOnLoad } from '@general/helpers';
import './privacy-checkbox.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initPrivacyCheckbox = (context) => {
  const snippetContainer = context.classList.contains('privacy-checkbox__container')
    ? context
    : context.closest('.privacy-checkbox__container');
  if (!snippetContainer || snippetContainer.classList.contains('privacy-checkbox__container--initialized')) return;

  const privacyCheckbox = snippetContainer.querySelector('input[type="checkbox"]');
  const formElement = snippetContainer.querySelector('.form-element');
  const form = snippetContainer.closest('form');
  if (privacyCheckbox && formElement && form) {
    const submit = form.querySelector('[type="submit"]');
    privacyCheckbox.addEventListener('invalid', () => {
      if (submit) submit.disabled = true;
      formElement.classList.add('error');
      privacyCheckbox.setAttribute('aria-invalid', 'true');
    });

    privacyCheckbox.addEventListener('change', () => {
      if (submit) submit.disabled = false;
      formElement.classList.remove('error');
      privacyCheckbox.removeAttribute('aria-invalid');
    });
  }
  snippetContainer.classList.add('privacy-checkbox__container--initialized');
};

execOnLoad(window.dAgency.initPrivacyCheckbox, '.privacy-checkbox__container');
